import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'
import 'lib-flexible' //rem
import '@/icons' // icon

import BaiduMap from 'vue-baidu-map'

import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

// set ElementUI lang to EN
Vue.use(ElementUI)
Vue.use(BaiduMap, {
  ak: 'GvGFyIFxDr1gxit4EpzaA0NDUk40jXty' // 替换为你的百度地图AK
})
Vue.config.productionTip = false
new Vue({
  el: '#app',
  data() {
    return {
      downloadUrl: 'http://10.9.13.41:8020/subOperation'
    }
  },
  router,
  store,
  render: h => h(App)
})